/**
 * Use Case: Fetch Merchants Dropdown
 * Business logic for fetching the list of merchants for dropdown selection.
 */

import type { MerchantDropdownItem } from "../model/RewardCatalogModel";
import type { IRewardCatalogRepository } from "../repository/IRewardCatalogRepository";
import { rewardCatalogContainer, TYPES } from "../../di/RewardCatalogModule";

/**
 * Fetch the list of merchants for dropdown selection
 */
export const FetchMerchantsDropdownUseCase = async (): Promise<
  readonly MerchantDropdownItem[]
> => {
  const repository = rewardCatalogContainer.get<IRewardCatalogRepository>(
    TYPES.IRewardCatalogRepository
  );
  return repository.fetchMerchantsDropdown();
};

